module.exports = __webpack_public_path__ + "img/Administration_grey.3dd5628a.svg";